































import { Component, Vue } from "vue-property-decorator";
import { mapState, mapActions } from "vuex";
import { Action } from "vuex-class";
import notificationService from "@/services/notificationService";
import cCard from "@/components/default/Card.vue";
import cDatagrid from "@/components/default/Datagrid.vue";
import axios from "axios";
import cPopup from "@/components/default/Popup.vue";
import { DxSelectBox } from "devextreme-vue/select-box";
import { DxLookup } from "devextreme-vue";
import DataSource from "devextreme/data/data_source";
import dxCustomStore from "devextreme/data/custom_store";
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";

import {
  DxDataGrid,
  DxEditing,
  DxStateStoring,
  DxColumn,
} from "devextreme-vue/data-grid";
import {
  CreateNoteTypesCommand,
  DeleteNoteTypesCommand,
  NoteType,
  NoteTypesClient,
  UpdateNoteTypesCommand,
} from "@/data/web-api-client";

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    cCard,
    cDatagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxColumn,
    DxSelectBox,
    DxLookup,
  },
})
export default class NoteTypesTable extends Vue {
  private noteTypes!: NoteType[];

  private create!: any;
  private update!: any;
  private remove!: any;

  private async mounted() {
    this.getNoteTypes();
  }

  private async getNoteTypes() {
    this.noteTypes = await new NoteTypesClient(undefined, axios).getAll();
  }

  private addRow() {
    const table: any = this.$refs.grid;
    table.instance.addRow();
  }

  private initRow(e: any) {
    e.data.value = "";
  }

  private async createRow(e: any) {
    var noteType = e.data as NoteType;
    await new NoteTypesClient(undefined, axios)
      .addNoteType(
        new CreateNoteTypesCommand({
          value: noteType.value,
          icon: noteType.icon,
        })
      )
      .then(() => {
        this.GridInstance.cancelEditData();
        this.getNoteTypes();
      });
  }

  private async updateRow(e: any) {
    const noteType: NoteType = Object.assign(
      {},
      e.oldData as NoteType,
      e.newData
    );

    await new NoteTypesClient(undefined, axios)
      .updateNoteType(
        new UpdateNoteTypesCommand({
          noteTypeId: noteType.id,
          value: noteType.value,
          icon: noteType.icon,
          order: noteType.order,
        })
      )
      .then(() => {
        this.GridInstance.cancelEditData();
        this.getNoteTypes();
      });
  }

  private async deleteRow(e: any) {
    await new NoteTypesClient(undefined, axios)
      .deleteNoteType(new DeleteNoteTypesCommand({ noteTypeId: e.data.id }))
      .then(() => {
        this.getNoteTypes();
        e.cancel = true;
      });
  }

  get columns() {
    return [
      {
        dataField: "value",
        caption: "Naam",
      },
      {
        dataField: "icon",
        caption: "Icon",
        lookup: {
          dataSource: this.icons,
          displayExpr: "text",
          valueExpr: "icon",
        },
      },
    ];
  }

  get icons() {
    return [
      {
        id: 1,
        icon: "fa fa-sticky-note",
        text: "Memo",
      },
      {
        id: 2,
        icon: "fa fa-phone",
        text: "Telefoon",
      },
      {
        id: 3,
        icon: "fa fa-envelope",
        text: "Mail",
      },
      {
        id: 4,
        icon: "fa fa-comments",
        text: "Meeting",
      },
      {
        id: 5,
        icon: "fa fa-comment",
        text: "Verslag",
      },
      {
        id: 6,
        icon: 'fa fa-circle-notch',
        text: 'Progressie'
      }
    ];
  }

  get GridInstance() {
    return ((this.$refs.grid as Vue).$refs.noteTypesTable as any).instance;
  }
}
